import useMobile from "customHooks/useMobile";
import useTranslation from "next-translate/useTranslation";
import CustomBreadCrumbs from "../components/ReuseableCompos/CustomBreadCrumbs";
import CustomJumbotron from "../components/ReuseableCompos/CustomJumbotron";

const GeneralDonateLayout = ({ children }) => {
  const { t } = useTranslation("common");
  const matches = useMobile("lg");

  return (
    <div className={`mb-0 mt-lg-0 ${matches?"":"container"}`}>
      <CustomJumbotron
        p="py-4 px-0"
        m="mt-0"
        breadCrumbM="my-0"
        className=" border-bottom"
        title={t(`donate_jumbotron`)}
        desc={t(`sections_donate_jumbtron_desc`)}
        customBreadCrumbs={<CustomBreadCrumbs />}
        borderBottom={false}
      />
      <div className={matches ? "" : " px-0"}>{children}</div>
    </div>
  );
};

export default GeneralDonateLayout;
